import script from "./SocialSharing.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialSharing.vue?vue&type=script&setup=true&lang=js"

import "./SocialSharing.vue?vue&type=style&index=0&id=38b3d83f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b3d83f"]])

export default __exports__